import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { State } from '../redux/redux.state';
import { Login } from '../types/login';
import client from '../clients/client';

const initialState: State<Login> = {
  data: { username: 'admin', password: '', authenticated: false },
  status: 'idle',
};

export const loginUser = createAsyncThunk<void, Login>(
  'auth/login',
  async ({ username, password }: Login, { rejectWithValue }) => {
    try {
      const { data } = await client.post('/login', { username, password });
      return data;
    } catch (err: any) {
      const { status, data } = err;
      return rejectWithValue({ status, errorMessage: data });
    }
  }
);

export const authSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(loginUser.fulfilled, (state) => {
        state.status = 'successful';
        state.data = { username: '', password: '', authenticated: true };
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = 'error';
        state.errors = action.payload;
      });
  },
});

export default authSlice.reducer;
